module.exports = __webpack_public_path__ + "static/media/flashbet.5689e3ee.svg";